import useUser from "../../../../../core/hooks/use-user";
import { toast } from "../../../../../core/helpers/message-helper";
import Datatable from "../../../../../core/ui/components/Datatable";
import { API_DOMAIN, API_URL } from "../../../../../core/config/env";
import ContentWrapper from "../../../../../core/ui/components/Layout/ContentWrapper";

const SolicitudesCerradas = () => {
    const { getAccessToken } = useUser();
    const token = getAccessToken();

    let tableButtons = [];

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "solicitudes-cerradas",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: true,
        processing: true,
        pageLength: 5,
        dom: "Bfrtip",
        id: "tablaSolicitudesCerradas",
        buttons: tableButtons,
        select: {
            style: "single",
        },
        ajax: {
            url: `${API_URL}/solicitudes/solicitudesCerradas`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de las solicitudes cerradas"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "fecha_solicitud" },
            {
                data: null,
                defaultContent: `
                    <button class="avances btn btn-primary btn-sm mt-1" title="Avances"><i class="fas fa-clipboard"></i></button> <br>
                    <button class="btn btn-success btn-sm mt-1 btn-whatsapp" title="Compartir WhatsApp"><i class="fab fa-whatsapp"></i></button> <br>
                    <button class="btn btn-secondary btn-sm mt-1" title="Copiar"><i class="far fa-copy"></i></button>`,
            },
            { data: "detalle" },
            { data: "parametro_prioridad_id" },
            { data: "parametro_estado_solicitud_id" },
            { data: "colaborador_asignado" },
            { data: "descripcion" },
            { data: "adjunto", defaultContent: "" },
        ],
        columnDefs: [
            {
                targets: [4],
                createdCell: function (td, cellData) {
                    td.classList.add(
                        cellData == "BAJA"
                            ? "text-primary"
                            : cellData == "MEDIA"
                            ? "text-secondary"
                            : cellData == "MEDIA-ALTA"
                            ? "text-warning"
                            : "text-danger"
                    );
                    td.classList.add("text-bold");
                },
            },
            {
                targets: [5],
                createdCell: function (td, cellData) {
                    td.classList.add(
                        cellData == "SIN ASIGNAR"
                            ? "text-warning"
                            : cellData == "PROCESO"
                            ? "text-primary"
                            : "text-danger"
                    );
                    td.classList.add("text-bold");
                },
            },
            {
                targets: [6],
                createdCell: function (td, cellData) {
                    td.classList.add(
                        cellData == "SIN ASIGNAR"
                            ? "text-danger"
                            : td.classList.add("text-bold")
                    );
                    td.classList.add("text-bold");
                },
            },
            {
                targets: [8],
                createdCell: function (td, adjunto) {
                    const path = `${API_DOMAIN}${adjunto}`;
                    const btnAdjunto = `
                        <a class="btn btn-warning btn-sm mr-1 mt-1" href="${path}" ><i class="fas fa-file-download"></i></a>
                    `;
                    td.innerHTML = btnAdjunto;
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>MESA DE AYUDA / Soportes Cerrados</div>
            </div>
            <Datatable options={dtOptions}>
                <table
                    className="w-100 table table-hover"
                    id="tablaSolicitudesCerradas"
                >
                    <thead className="bg-dark">
                        <tr>
                            <th className="text-center text-white">Ticket</th>
                            <th className="text-center text-white">Fecha</th>
                            <th className="text-center text-white">Acciones</th>
                            <th className="text-center text-white">Detalle</th>
                            <th className="text-center text-white">
                                Prioridad
                            </th>
                            <th className="text-center text-white">Estado</th>
                            <th className="text-center text-white">
                                Asignación
                            </th>
                            <th className="text-center text-white">
                                Descripcion
                            </th>
                            <th className="text-center text-white">Adjunto</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
        </ContentWrapper>
    );
};

export default SolicitudesCerradas;
